import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { Trans, withNamespaces } from 'react-i18next';

import { Link } from 'core/routing';
import { Banner } from 'components';

@withNamespaces()
@inject('routerStore')
@observer
export class VersionWarning extends React.Component {
  render() {
    const {
      routerStore,
      repoManager: { atHead },
    } = this.props;

    const latestRoute = routerStore.route.name
      .split('.')
      .filter(e => e !== 'version')
      .join('.');
    const latestParams = Object.assign({}, routerStore.route.params);
    delete latestParams.contributionId;
    const atFilesRoute = latestRoute.endsWith('files');
    const atFilesSubRoute = latestRoute.endsWith('directory');

    if (atHead) return null;

    return (
      <Banner variant='warning' customIcon='time_travel'>
        <Trans>
          You are viewing this project at a{' '}
          <Link
            name={
              atFilesRoute
                ? latestRoute.replace('files', 'contribution')
                : atFilesSubRoute
                ? latestRoute.replace('files.directory', 'contribution')
                : `${latestRoute}.contribution`
            }
            params={routerStore.route.params}
          >
            specific point in time
            {atFilesRoute || atFilesSubRoute
              ? ``
              : ` (#${routerStore.route.params.contributionId})`}
          </Link>
          . In order to see the latest version,{' '}
          <Link name={latestRoute} params={latestParams}>
            click here
          </Link>
        </Trans>
      </Banner>
    );
  }
}

VersionWarning.propTypes = {
  routerStore: PropTypes.object,
  repoManager: PropTypes.object,
};
